import {Box, TextField, Typography} from '@material-ui/core';
import {ChangeEvent, useEffect, useState, FormEvent} from 'react';
import {useHistory, useLocation} from 'react-router';
import {Button, Loading} from '../../components';
import {FORCED_PASSWORD_CHANGE_PAGE} from '../../const/routes';
import {useAppDispatch, useAppSelector} from '../../hooks/customReduxHooks';
import {
    selectAuthStatus,
    selectAuthUserData,
    selectEmailConfirmed,
    verifyEmailCode,
} from '../../store/auth';
import useStyles from './EmailVerificationPageStyles';
import useQuery from '../../hooks/useQuery';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../const/i18nNamespaces';
import {EMAIL_CONFIRMATION} from '../../const/auth';

type LocationState = {
    email: string;
};

const EmailVerificationPage = () => {
    const dispatch = useAppDispatch();
    const authStatus = useAppSelector(selectAuthStatus);
    const status = useAppSelector(selectAuthStatus);
    const authUserData = useAppSelector(selectAuthUserData);
    const [error, setError] = useState<string>('');

    const location = useLocation<LocationState>();
    const history = useHistory();
    const classes = useStyles();
    const [code, setCode] = useState<string>('');
    const query = useQuery();
    const returnUrl = query.get('returnUrl');
    const encodedReturnUrl = '?returnUrl=' + encodeURIComponent(returnUrl);

    const {t} = useTranslation(i18nNamespaces.SETTINGS);

    useEffect(() => {
        const {email} = location.state;
        if (authUserData?.role !== EMAIL_CONFIRMATION) {
            if (returnUrl && returnUrl !== 'null') {
                history.push({
                    pathname: FORCED_PASSWORD_CHANGE_PAGE,
                    state: {email},
                    search: encodedReturnUrl,
                });
            } else {
                history.push(FORCED_PASSWORD_CHANGE_PAGE, {email});
            }
        }
    }, [location, history, returnUrl, authUserData]);

    useEffect(() => {
        if (status === 'failed') setError(t('incorrectCodeTryAgain'));
    }, [status]);

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        const {email} = location.state;
        setError('');
        dispatch(verifyEmailCode({email, code}));
    };

    const onCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
        setError('');
    };

    return (
        <div className={classes.container}>
            <Loading loading={authStatus === 'loading'} withBackdrop />
            <Box
                py={3}
                justifyContent="center"
                alignItems="center"
                display={'flex'}
                flexDirection="column"
            >
                <Typography variant={'h3'}>
                    {t('confirmYourEmailAddress')}
                </Typography>
                <Box component="span" pt={2} pb={4}>
                    {t('weSendToYouEmailWithcode')}
                </Box>
                <form onSubmit={onSubmit}>
                    <Box mb={2}>
                        <TextField
                            className={classes.input}
                            size={'small'}
                            label={t('entedCodeFromEmail')}
                            type="text"
                            id="emailCode"
                            variant="outlined"
                            value={code}
                            onChange={onCodeChange}
                            autoComplete="off"
                            error={!!error}
                            helperText={error && error}
                            autoFocus
                        />
                    </Box>
                    <Button
                        type="submit"
                        color="secondary"
                        variant="contained"
                        className={classes.button}
                        disabled={!code}
                    >
                        {t('next')}
                    </Button>
                </form>
            </Box>
        </div>
    );
};

export default EmailVerificationPage;
